import booleanValue from './booleanValue.js';
import boolYesNo from './boolYesNo.js';
import bsChecked from './bsChecked.js';
import currency from './currency.js';
import dateString from './dateString.js';
import dateTimeString from './dateTimeString.js';
import fillColor from './fillColor.js';
import jewishLeaveReport from './jewishLeaveReport.js';
import jewishValueReport from './jewishValueReport.js';
import leaveTakenReportRateValueReport from './leaveTakenReportRateValueReport.js';
import nullValue from './nullValue.js';
import parseTranslationString from './parseTranslationString.js';
import pascalCase from './pascalCase.js';
import returnKey from './returnKey.js';
import roundValue from './roundValue.js';
import select2 from './select2.js';
import thousands from './thousands.js';
import zeroNullValue from './zeroNullValue.js';
import zeroNullValueRound from './zeroNullValueRound.js';

export default [
	booleanValue,
	boolYesNo,
	bsChecked,
	currency,
	dateString,
	dateTimeString,
	fillColor,
	jewishLeaveReport,
	jewishValueReport,
	leaveTakenReportRateValueReport,
	nullValue,
	parseTranslationString,
	pascalCase,
	returnKey,
	roundValue,
	select2,
	thousands,
	zeroNullValue,
	zeroNullValueRound
];
